import React from "react";
import "../css/Trainers.css";

const Trainers = () => {
  const coaches = [
    {
      name: "Lena Hart",
      specialty: "Mobility & Flow",
      img: "https://images.pexels.com/photos/4327033/pexels-photo-4327033.jpeg",
      bio: "Gentle, breath-led mobility sessions focused on alignment and freedom."
    },
    {
      name: "Cal Mason",
      specialty: "Strength Foundations",
      img: "https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg",
      bio: "Grounded strength training that builds resilience from the core outward."
    },
    {
      name: "Tara Wells",
      specialty: "Holistic Conditioning",
      img: "https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg",
      bio: "Mind–body conditioning for balance, posture, and calm performance."
    },
    {
      name: "Rio Carter",
      specialty: "Breath & Recovery",
      img: "https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg",
      bio: "Breathwork paired with soft movement for deep recovery and clarity."
    }
  ];

  return (
    <div className="trainers5">

      {/* ================= HERO ================= */}
      <section className="tr-hero">
        <div className="hero-circle"></div>

        <h1>Meet Your Guides</h1>
        <p>The EarthFit coaches — grounded, calm, and deeply connected to mindful movement.</p>
      </section>


      {/* ================= LEAF TRAINER GRID ================= */}
      <section className="tr-grid">
        {coaches.map((c, i) => (
          <div className="tr-card" key={i}>
            <div className="tr-img-wrap">
              <img src={c.img} alt={c.name} />
            </div>

            <h3>{c.name}</h3>
            <span className="tr-role">{c.specialty}</span>

            <p className="tr-bio">{c.bio}</p>
          </div>
        ))}
      </section>


      {/* ================= EARTH PANEL ================= */}
      <section className="tr-end">
        <h2>Grow With Mentors Who Move With Purpose</h2>
        <p>Every coach brings patience, grounding, and intention into your practice.</p>
      </section>

    </div>
  );
};

export default Trainers;
